const INTERNAL_SERVER_ERROR = {
  title: 'Interna greška',
  message: 'Interna greška',
  repeatButton: false
}
const LOCAL_SIGNER_INTERNAL_MESSAGE = {
  title: 'Greška [001]',
  message: 'Kreiranje elektroničkog potpisa nije moguće. Molimo Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: false
}

const USER_CANCELLED_OPERATION = {
  title: 'Greška [004]',
  message: 'Izrada elektroničkog potpisa je prekinuta na zahtjev korisnika',
  repeatButton: true,
  //redirectButton: false
}

const CERTIFICATES_NOT_FOUND = {
  title: 'Greška [005]',
  message: 'Potpisni certifikat nije pronađen. Provjerite da li je Vaša kartica umetnuta u čitač kartica. Ukoliko je kartica umetnuta u čitač, a greška se i dalje javlja, molimo Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: true,
}

const PRIVATE_KEY_USAGE_PERIOD_EXPIRED = {
  title: 'Greška [006]',
  message: 'Potpisnom certifikatu koji ste odabrali je istekao rok valjanosti. Za korištenje usluge potpisni certifikat mora biti valjan',
  repeatButton: false,
}
const CERTIFICATE_EXPIRED = {
  title: 'Greška [007]',
  message: 'Potpisnom certifikatu koji ste odabrali je istekao rok valjanosti. Za korištenje usluge potpisni certifikat mora biti valjan',
  repeatButton: false,
}
const CERTIFICATE_NOT_YET_VALID = {
  title: 'Greška [008]',
  message: 'Potpisni certifikat koji ste odabrali nije aktivan. Za korištenje usluge certifikat mora biti aktivan. Molimo Vas provjerite status Vašeg certifikata sa korisničkom službom izdavatelja certifikata.',
  repeatButton: false,
}
const CERTIFICATE_NOT_VALID = {
  title: 'Greška [009]',
  message: 'Sa vašeg računala nije bilo moguće provjeriti valjanost odabranog certifikata kod potpisivanja.\n Kontaktirajte svog administratora da provjeri pristup vašeg računala OCSP poslužitelju.',
  repeatButton: false,
}
const CERTIFICATE_REVOKED = {
  title: 'Greška [010]',
  message: 'Status potpisnog certifikata koji ste odabrali je opozvan. Za korištenje usluge certifikat mora biti valjan. Molimo Vas provjerite status Vašeg certifikata sa korisničkom službom izdavatelja certifikata',
  repeatButton: false,
}
const CERTIFICATE_UNABLE_TO_GET_CRL ={
  title: 'Greška [011]',
  message: 'Potpisni certifikat nije pronađen. Provjerite da li je Vaša kartica umetnuta u čitač. Ukoliko je kartica umetnuta u čitač, a greška se i dalje javlja, molimo Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: false,
} 
const CERTIFICATE_CRL_INVALID = {
  title: 'Greška [002]',
  message: 'CRL lista nije valjana',
  repeatButton: false,
}
const PRIVATE_KEY_NOT_AVAILABLE = {
  title: 'Greška [012]',
  message: 'Potpisni certifikat nije pronađen. Provjerite da li je Vaša kartica umetnuta u čitač. Ukoliko je kartica umetnuta u čitač, a greška se i dalje javlja, molimo Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: true,
}
const PIN_VERIFICATION_FAILED = {
  title: 'Greška [013]',
  message: 'Provjera PIN-a nije uspjela. Molim Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: false,
}
const EID_SIGNER_NOT_AVAILABLE = {
  title: 'Greška [014]',
  message: 'Za uspješno provođenje postupka kreiranja elektroničkog potpisa (korištenjem  Certilia potpisnog certifikata) eSigner servis mora biti dostupan. Ukoliko eSigner nije automatski pokrenut molimo Vas da ga pokrene ručno kroz Start Programs izbornik. Ukoliko se greška i dalje javlja, molimo Vas kontaktirajte korisničku službu izdavatelja certifikata',
  repeatButton: true
}
const DIGITAL_SIGNATURE_INTEGRATION_FAILED = {
  title: 'Greška [015]',
  message: 'Greška prilikom integracije digitalnog potpisa u dokument.',
  repeatButton: false,
  redirectButton: true
}
const TOKEN_EXPIRED = {
  title: 'Greška [016]',
  message: 'Token je neispravan ili je istekao.',
  repeatButton: false 
}
const INCORECT_PASSWORD = {
  title: 'Greška [017]',
  message: 'Neispravna lozinka',
  repeatButton: true,
}
const CLOUD_ERROR = {
  title: 'Greška [018]',
  message: 'Došlo je do greške prilikom potpisivanja u oblaku',
  repeatButton: false,
}
const HASH_ERROR = {
  title: 'Greška [019]',
  message: 'Usluga nije poslala sve potrebne podatke',
  repeatButton: false,
}

const VERIFICATION_CODE_NOT_FOUND_ERROR = {
  title: 'Greška [020]',
  message: 'Nema podataka za traženi broj zapisa',
  repeatButton: false,
}

const MULTIPLE_DOCUMENT_SEND_TO_LOCAL_SIGNER = {
  title: 'Greška [021]',
  message: 'Certifikatom sa kartice nije moguće potpisati/pečatirati više dokumenata',
  repeatButton: true
}


const VERIFICATION_ERROR = {
  title: 'Greška [23]',
  message: 'Došlo je do greške prilikom validacije',
  repeatButton: true
}

const GENERATE_PDF_ERROR = {
  title: 'Greška [24]',
  message: 'Došlo je do greške prilikom generiranja PDF izvještaja',
  repeatButton: false
}

const USER_CERTIFICATE_NOT_RETURNED_FROM_ANOTHER_TSP = {
  title: 'Greška [25]',
  message: 'Nema certifikata od korisnika',
  repeatButton: false
}


const TRANSACTION_ALREADY_SIGNED = {
  title: 'Greška [27]',
  message: 'Transakcija je već potpisana',
  repeatButton: false
}

const DOCUMENTS_NOT_RETURNED_FROM_ANOTHER_TSP = {
  title: 'Greška [28]',
  message: 'Pružatelj usluge nije potpisao dokumente',
  repeatButton: false
}

const MULTIPLE_DOCUMENT_SEND_TO_OTHER_SIGNER = {
  title: 'Greška [29]',
  message: 'Odabrani pružatelj usluge povjerenja nema mogućnost potpisivanja/pečatiranja više dokumenata',
  repeatButton: true
}

// Greške kod ugradnje

const INVALID_PERSON_NAME_SURNAME = {
  title: 'Greška [30]',
  message: 'Greška prilikom ugradnje potpisa u dokument. Neispravno ime i prezime osobe.',
  repeatButton: false
}

const INVALID_PERSON_PIN = {
  title: 'Greška [31]',
  message: 'Greška prilikom ugradnje potpisa u dokument. Neispravan OIB osobe.',
  repeatButton: false
}

const UNSUPPORTED_USER_CERTIFICATE_USAGE_SIGN = {
  title: 'Greška [32]',
  message: "Greška prilikom ugradnje potpisa u dokument. Namjena korisničkog certifikata nije potpisivanje.",
  repeatButton: false
}

const INVALID_ORGANIZATION_NAME = {
  title: 'Greška [33]',
  message: 'Greška prilikom ugradnje pečata u dokument. Neispravan naziv organizacije.',
  repeatButton: false
}

const INVALID_ORGANIZATION_VAT = {
  title: 'Greška [34]',
  message: 'Greška prilikom ugradnje pečata u dokument. Neispravan OIB organizacije.',
  repeatButton: false
}

const UNSUPPORTED_USER_CERTIFICATE_USAGE_SEAL = {
  title: 'Greška [35]',
  message: "Greška prilikom ugradnje pečata u dokument. Namjena korisničkog certifikata nije pečatiranje.",
  repeatButton: false
}

const ANOTHER_TSP_MIDDLEWARE_NOT_INSTALLED = {
  title: 'Greška [36]',
  message: 'Programska podrška odabranog pružatelja usluge povjerenja nije dostupna na vašem računalu.',
  repeatButton: true
}

const INVALID_USER_SECURITY_LEVEL = {
  title: 'Greška [37]',
  message: 'Korisnik nije prijavljen ili nije prijavljen sa zadovoljavajućom razinom sigurnosti',
  repeatButton: false
}

const FINA_11101 = {
  title: 'FINA greška [11101]',
  message: 'Greška u komunikaciji s vanjskim servisom Fine',
  repeatButton: false
}

const FINA_11102 = {
  title: 'FINA greška [11102]',
  message: 'Nije moguće pokrenuti proces potpisivanja jer je potpisivanje već u tijeku',
  repeatButton: false
}

const FINA_11103 = {
  title: 'FINA greška [11103]',
  message: 'Niti jedan certifikat ne zadovoljava uvjete za potpis',
  repeatButton: false
}

const FINA_11104 = {
  title: 'FINA greška [11104]',
  message: 'Greška kod potpisivanja. Obratite se korisničkoj podršci Fine',
  repeatButton: false
}

const FINA_11201 = {
  title: 'FINA obavijest [11201]',
  message: 'Dostupna nova verzija potpisnog modula za ažuriranje ',
  repeatButton: true
}

const FINA_11202 = {
  title: 'FINA obavijest [11202]',
  message: 'Korisnik je odustao od akcije potpisivanja ',
  repeatButton: true
}

const FINA_11203 = {
  title: 'FINA obavijest [11203]',
  message: 'Isteklo je vrijeme za korisnički odgovor',
  repeatButton: true
}

const DEFAULT_ERROR = {
  title: 'Greška',
  message: 'Došlo je do greške',
  repeatButton: false,
  redirectButton: false
}


export const getUIErrorMessage = (error, errorURL) =>{
  console.log('err mes', JSON.stringify(error))
  switch(error.code) {
    case 0:
      return {
        ...error,
        ...EID_SIGNER_NOT_AVAILABLE
      }
    case 1:
      return {
        ...error,
        ...USER_CANCELLED_OPERATION
      }
    case 2:
      return {
        ...error,
        ...LOCAL_SIGNER_INTERNAL_MESSAGE
      }
    case 3:
      return {
        ...error,
        ...LOCAL_SIGNER_INTERNAL_MESSAGE
      }
    case 4:
      return {
        ...error,
        ...LOCAL_SIGNER_INTERNAL_MESSAGE
      }
    case 5:
      return {
        ...error,
        ...USER_CANCELLED_OPERATION
        //errorURL
      } 
    case 6:
      return {
        ...error,
        ...CERTIFICATES_NOT_FOUND
      }
    case 7:
      return {
        ...error,
        ...PRIVATE_KEY_USAGE_PERIOD_EXPIRED
      };
    case 8:
      return {
        ...error,
        ...CERTIFICATE_EXPIRED
      }
    case 9:
      return {
        ...error,
        ...CERTIFICATE_NOT_YET_VALID
      }
    case 10:
      return {
        ...error,
        ...CERTIFICATE_NOT_VALID
      }
    case 11:
      return {
        ...error,
        ...CERTIFICATE_REVOKED
      }
    case 12:
      return {
        ...error,
        ...CERTIFICATE_UNABLE_TO_GET_CRL
      }
    case 13:
      return {
        ...error,
        ...CERTIFICATE_CRL_INVALID
      }
    case 14:
      return {
        ...error,
        ...PRIVATE_KEY_NOT_AVAILABLE
      }
    case 15:
      return {
        ...error,
        ...PIN_VERIFICATION_FAILED
      }
    case 16:
      return {
        ...error, ...DIGITAL_SIGNATURE_INTEGRATION_FAILED, errorURL
      }
    case 17:
      return {
        ...error, ...TOKEN_EXPIRED
      };
    case 18: 
      return {
        ...error,
        ...INCORECT_PASSWORD
      }
    case 19:
      return {
        ...error,
        ...CLOUD_ERROR
      }
    case 20: 
      return {
        ...error,
        ...HASH_ERROR
      }
    case 21: 
      return {
        ...error,
        ...VERIFICATION_CODE_NOT_FOUND_ERROR
      }
    case 22:
      return {
        ...error,
        ...MULTIPLE_DOCUMENT_SEND_TO_LOCAL_SIGNER
      }
    case 23:
      return {
        ...error,
        ...VERIFICATION_ERROR
      }
    case 24: 
      return {
        ...error,
        ...GENERATE_PDF_ERROR
      }
    case 25: {
      return {
        ...error,
        ...USER_CERTIFICATE_NOT_RETURNED_FROM_ANOTHER_TSP
      }
    }
    case 26: 
      return {
        title: 'Greška [26]',
        repeatButton: true,
        ...error
      }
    case 27: {
      return {
        ...error,
        ...TRANSACTION_ALREADY_SIGNED
      }
    }
    case 28: {
      return {
        ...error,
        ...DOCUMENTS_NOT_RETURNED_FROM_ANOTHER_TSP
      }
    }
    case 29:
      return {
        ...error,
        ...MULTIPLE_DOCUMENT_SEND_TO_OTHER_SIGNER
      }
    case 36:
      return {
        ...error,
        ...ANOTHER_TSP_MIDDLEWARE_NOT_INSTALLED
      }
    case 37:
        return {
          ...error,
          ...INVALID_USER_SECURITY_LEVEL
        }
    case 40: 
      return {
        title: 'Greška [FINA]',
        ...error,
        repeatButton: false,
      }
    case 85:
    case 95:
      return {
        ...error,
        ...INVALID_PERSON_NAME_SURNAME
      }
    case 86:
    case 96:
      return {
        ...error,
        ...INVALID_PERSON_PIN
      }
    case 810:
    case 910: {
      return {
        ...error,
        ...INVALID_ORGANIZATION_NAME
      }
    }
    case 811:
    case 911: {
      return {
        ...error,
        ...INVALID_ORGANIZATION_VAT
      }
    }
    case 871:
    case 971: {
      return {
        ...error,
        ...UNSUPPORTED_USER_CERTIFICATE_USAGE_SIGN
      }
    }
    case 872:
    case 972: {
      return {
        ...error,
        ...UNSUPPORTED_USER_CERTIFICATE_USAGE_SEAL
      }
    }
    case 11101: {
      return {
        ...error,
        ...FINA_11101
      }
    }
    case 11102: {
      return {
        ...error,
        ...FINA_11102
      }
    }
    case 11103: {
      return {
        ...error,
        ...FINA_11103
      }
    }
    case 11104: {
      return {
        ...error,
        ...FINA_11104
      }
    }
    case 11201: {
      return {
        ...error,
        ...FINA_11201
      }
    }
    case 11202: {
      return {
        ...error,
        ...FINA_11202
      }
    }
    case 11203: {
      return {
        ...error,
        ...FINA_11203
      }
    }
    default:
      return { ...error, ...DEFAULT_ERROR}
   }
};


/*
export const showRepeatButton = (errorCode) => {
 const showRepeatButtonCodes = [0, 5, 6, 14, 18]
 return showRepeatButtonCodes.includes(errorCode);
};

export const redirectOnError = (errorCode) => {
  const redirectErrorCodes = [16];
  return redirectErrorCodes.includes(errorCode);
}

*/